// import React, { useEffect, useState} from 'react';
// import axios from "axios";
// import toast from "react-hot-toast";
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchBrand } from '../../../../redux/userSetting';


// function EditOtherDescription({ register,productName,errors,setValue,watch,productImages,setProductImages,thumbnailImage,setThumbnailImage }) {
//  const dispatch = useDispatch();
//   const API_KEY = process.env.REACT_APP_TRANSLATION_API_KEY;
//   const {brandList} = useSelector((state) => state.usersetting);
//   // const languages = [
//   //   { code: "ar", name: "Arabic" },
//   //   { code: "hi", name: "Hindi" },
//   //   { code: "ml", name: "Malayalam" },
//   // ];
//   const [thumbnailPreview, setThumbnailPreview] = useState(null);
//   // const [thumbnailImage, setThumbnailImage] = useState(null);
  
//   const [productImagePreviews, setProductImagePreviews] = useState([]);
//   const [fileList, setFileList] = useState([]);

// const handleThumbnailChange = (event) => {
//   const file = event.target.files[0];
//   if (!file) {
//     console.warn("No file selected");
//     setThumbnailImage(""); // ✅ Convert null to empty string
//     return;
//   }
//   else
//   {setThumbnailImage(file);}
// };

// // const handleProductImagesChange = (event) => {
// //   const files = Array.from(event.target.files);
// //   console.log(files, "Image upload");

// //   const fileArray = files.map((file) => URL.createObjectURL(file));
// //   console.log(fileArray, "FILE Image");

// //   if (productImages.length + files.length > 3) {
// //       toast.error("You can upload a maximum of 3 images.");
// //       return;
// //   }

// //   const newFiles = fileArray.map((url) => ({
// //       dImage: url,
// //   }));

// //   console.log(newFiles, "NEWFILES");

// //   // Correctly update state
// //   setProductImages((prevImages) => [...prevImages, ...newFiles]);
// //   setProductImagePreviews((prevPreviews) => [...prevPreviews, ...fileArray]);
// // };

// const handleProductImagesChange = (event) => {
//     const files = Array.from(event.target.files);

//     if (productImages.length + files.length > 3) {
//       toast.error("You can upload a maximum of 3 images.");
//       return;
//     }
//     else {
// setProductImages(files);}

//   };


// const removeProductImage = (index) => {
//   const updatedImages = [...productImages];
//   const updatedPreviews = [...productImagePreviews];
//   updatedImages.splice(index, 1);
//   updatedPreviews.splice(index, 1);
//   setProductImages(updatedImages);
//   setProductImagePreviews(updatedPreviews);
// };

// useEffect(() => {
//   dispatch(fetchBrand()) 
//  }, [])
//   return (

 
//     <div>
//     <div>
//       <div className="modal-body custom-modal-body">
//         <div className="branch-tabs col-12 align-items-center justify-content-between">
//           {Object.keys(errors || {})
//             .map((key) => errors[key]?.message)
//             .find(Boolean) && (
//             <span className="error text-danger text-sm">
//               {Object.keys(errors || {})
//                 .map((key) => errors[key]?.message)
//                 .find(Boolean)}
//             </span>
//           )}
//         </div>
 
//         <div className="row">
//     <div className="col-md-6 col-sm-12">
//             <div className="input-blocks d-flex align-items-center">
//               <label  htmlFor="Short Name"
//                      className="me-2"
//                   style={{ width: "100px" }}>Detailed Description</label>
//              <textarea
//                   id="ShortName"
//                   placeholder="Detailed Description"
                
//                   rows={8}
//                   {...register("otherDescription.shortDescription", {
//                    // required: "Detailed Description is required",
//                   })}
//                 />
//               {errors?.ShortName && (
//                   <span className="error text-danger text-sm">
//                     {errors.ShortName.message}
//                   </span>
//                 )}
//             </div>
//           </div>
          
//           <div className="col-md-6 col-sm-12">
//             <div className="input-blocks d-flex align-items-center">
//               <label  htmlFor="Short Name"
//                      className="me-2"
//                   style={{ width: "100px" }}>Brand</label>
//               {/* <input type="text" placeholder=""  
//               {...register("otherDescription.manufactureID")}
//                /> */}
//                <select
//                   {...register("otherDescription.manufactureID")}
 
//                   className=" form-control"
                 
//                 >
//                   <option value="" disabled>
//                     Select Brand
//                   </option>
//                   {brandList?.map((group) => (
//                     <option key={group.guid} value={group.guid}>
//                       {group.name}
//                     </option>
//                   ))}
//                 </select>
//             </div>
//             <div className="input-blocks d-flex align-items-center">
//               <label  htmlFor="Short Name"
//                      className="me-2"
//                   style={{ width: "100px" }}>Min Price</label>
//               <input type="number"
//               className="form-control"
//               placeholder=""
//               min={0}
//               defaultValue={0}
//                {...register("otherDescription.minPrice")}
//                 />
           
//             </div>
//           </div>

//           {/* <div className="col-md-6 col-sm-12">
//             <div className="input-blocks d-flex align-items-center">
//               <label  htmlFor="Short Name"
//                      className="me-2"
//                   style={{ width: "100px" }}>Min Price</label>
//               <input type="number"
//               className="form-control"
//               placeholder=""
//               min={0}
//               defaultValue={0}
//                {...register("otherDescription.minPrice")}
//                 />
           
//             </div>
//           </div> */}
//        </div>

//         <div className="row mt-2 border p-2">
//                       <label><b>ReOrder: </b> </label>
//                       <div className="row">
//           <div className="col-md-6 col-sm-12">
//             <div className="input-blocks d-flex align-items-center">
//               <label htmlFor="Name"
//                      className="me-2"
//                   style={{ width: "100px" }}>Min Quantity<span className="text-danger">*</span></label>
//               <input type="number"
//               className="form-control"
//                placeholder=""
//                defaultValue={0}
//                min={0}
//                 {...register("otherDescription.minQty",{ required: "Min Quantity is required"  })} />
//               {errors?.MinQty && (
//               <span className="error text-danger text-sm">{errors.MinQty.message}</span>
//             )}
//             </div>
//           </div>
 
//           <div className="col-md-6 col-sm-12">
//             <div className="input-blocks d-flex align-items-center">
//               <label  htmlFor="Short Name"
//                      className="me-2"
//                   style={{ width: "100px" }}>Max Quantity<span className="text-danger">*</span></label>
//               <input type="number"
//               className="form-control"
//                placeholder=""
//                min={0}
//                 defaultValue={0}
//                  {...register("otherDescription.maxQty",{ required: "Short Name is required" })} />
//               {errors?.MaxQty && (
//               <span className="error text-danger text-sm">{errors.MaxQty.message}</span>
//             )}
//             </div>
//           </div>
//           <div className="col-md-6 col-sm-12">
//             <div className="input-blocks d-flex align-items-center">
//               <label  htmlFor="Short Name"
//                      className="me-2"
//                   style={{ width: "100px" }}>Reorder Level<span className="text-danger">*</span></label>
//               <input type="number"
//               className="form-control"
//                placeholder=""
//                min={0}
//                 defaultValue={0}
//                  {...register("otherDescription.reorderLevel",{ required: "ReorderLevel is required" })} />
//               {errors?.ReorderLevel && (
//               <span className="error text-danger text-sm">{errors.ReorderLevel.message}</span>
//             )}
//             </div>
//           </div>
 
//           <div className="col-md-6 col-sm-12">
//             <div className="input-blocks d-flex align-items-center">
//               <label  htmlFor="Short Name"
//                      className="me-2"
//                   style={{ width: "100px" }}>Reorder Quantity<span className="text-danger">*</span></label>
//               <input type="number"
//               className="form-control"
//                placeholder=""
//                min={0}
//                defaultValue={0}
//                {...register("otherDescription.reorderQty",{ required: "Reorder quantity is required" })} />
//               {errors?.ReorderQty && (
//               <span className="error text-danger text-sm">{errors.ReorderQty.message}</span>
//             )}
//             </div>
//           </div>
 
//           </div>
                     
//   </div>
//         <div className="row mt-3">
//         <label><b>Others: </b> </label>
//         <div className="d-flex align-items-center me-4">
//   <input type="checkbox" {...register("otherDescription.isMenuItem")} />
//   <label className="ms-2 mb-1">Quick Item</label>
// </div>
   
//         </div>
//         <div className="row mt-3">
//                   <label><b>Add Images: </b> </label>
//                      {/* Thumbnail Image Upload (Mandatory) */}
//                      <div className="col-md-6 col-sm-12">
//                     <div className="input-blocks">
//                       <label className="me-2" style={{ width: "150px" }}>Thumbnail Image (150x150 px) <span className="text-danger">*</span></label>
//                       <input type="file" accept="image/*"  onChange={handleThumbnailChange} />
//                       {errors?.thumbnailImage && <span className="error text-danger">{errors.thumbnailImage.message}</span>}
//                     </div>
//                     {thumbnailPreview && (
//                       <div className="mt-2">
//                         <img src={thumbnailPreview} alt="Thumbnail Preview" style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "5px" }} />
//                       </div>
//                     )}
//                   </div>
        
//                   {/* Product Detail Images (Multiple Uploads) */}
//                   <div className="col-md-6 col-sm-12">
//                     <div className="input-blocks">
//                       <label className="me-2" style={{ width: "150px" }}>Product Detail Images (550x550 px) </label>
//                       <input type="file" accept="image/*"  multiple onChange={handleProductImagesChange}  disabled = {productImages.length >= 3}/>
//                     </div>
//                     {productImagePreviews.length > 0 && (
//                       <div className="mt-2 d-flex flex-wrap">
//                         {productImagePreviews.map((image, index) => (
//                           <div key={index} className="position-relative me-2" style={{ width: "100px", height: "100px" }}>
//                             <img src={image} alt="Product Detail" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "5px" }} />
//                             <button type="button" className="btn btn-danger btn-sm position-absolute" style={{ top: "-5px", right: "-5px" }} onClick={() => removeProductImage(index)}>X</button>
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                      {productImages.length >= 3 && <span className="text-danger mt-1 d-block">Maximum 3 images allowed.</span>}
//                   </div>
        
//         </div>
//         <div className="col-lg-12"></div>
//       </div>
//     </div>
//   </div>
//   )
// }
 
// export default EditOtherDescription



import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { fetchBrand } from "../../../../redux/userSetting";
import { X } from "feather-icons-react/build/IconComponents";
import { PmGalleryIcon, PmImageIcon } from "./pmUi";

function EditOtherDescription({
  register,
  errors,
  setValue,
  watch,
 productData,
}) {
  const dispatch = useDispatch();
  const { brandList } = useSelector((state) => state.usersetting);
 
  const[productImages,setProductImages]=useState([]);
  const[thumbnailImage,setThumbnailImage]=useState([]);
  const API_BASE = "https://inventory-api.exodusvacations.in/";

  // ✅ Fetch brand list
  useEffect(() => {
    dispatch(fetchBrand());
  }, [dispatch]);

  // ✅ Preload existing images on edit
  useEffect(() => {
    if (productData) {
      // Thumbnail image
      if (productData.thumbImage) {
        const thumbUrl = `${API_BASE}${productData.thumbImage
          ?.trim()
          ?.replace(/^wwwroot\//, "")}`;
        setThumbnailImage([{ preview: thumbUrl }]);
      }

      // Product detail images
      if (productData.strProdImage) {
        const imgs = productData.strProdImage
          .split(",")
          .map((path) => ({
            preview: `${API_BASE}${path.trim().replace(/^wwwroot\//, "")}`,
          }));
        setProductImages(imgs);
      }
    }
  }, [productData]);

  // ✅ Handle thumbnail change
  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setThumbnailImage([{ file, preview: URL.createObjectURL(file) }]);
  };

  // ✅ Handle multiple product image upload (max 3)
  const handleProductImagesChange = (e) => {
    const files = Array.from(e.target.files);
    if (productImages.length + files.length > 3) {
      toast.error("You can upload a maximum of 3 images.");
      return;
    }

    const newImgs = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setProductImages((prev) => [...prev, ...newImgs]);
  };

  // ✅ Remove image from list
  const removeImage = (index) => {
    setProductImages((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="pm-panel">
      {/* 🔴 Error Display */}
      {Object.keys(errors || {})
        .map((key) => errors[key]?.message)
        .find(Boolean) && (
        <div className="pm-alert error">
          {Object.keys(errors || {})
            .map((key) => errors[key]?.message)
            .find(Boolean)}
        </div>
      )}

      {/* 🧾 Description + Brand */}
      <div className="pm-secthead">Description &amp; brand</div>
      <div className="pm-formgrid">
        <div className="pm-f tall">
          <label className="pm-flabel">Detailed Description</label>
          <textarea
            rows={8}
            placeholder="Detailed Description"
            {...register("otherDescription.shortDescription")}
          />
        </div>

        <div className="pm-f">
          <label className="pm-flabel">Brand</label>
          <select {...register("otherDescription.manufactureID")}>
            <option value="">Select Brand</option>
            {brandList?.map((group) => (
              <option key={group.guid} value={group.guid}>
                {group.name}
              </option>
            ))}
          </select>
        </div>

        <div className="pm-f">
          <label className="pm-flabel">Min Price</label>
          <input
            type="number"
            min={0}
            defaultValue={0}
            className="pm-num"
            {...register("otherDescription.minPrice")}
          />
        </div>
      </div>

      {/* 📦 Reorder Details */}
      <div className="pm-secthead gap">ReOrder</div>
      <div className="pm-formgrid">
        {[
          { name: "minQty", label: "Min Quantity" },
          { name: "maxQty", label: "Max Quantity" },
          { name: "reorderLevel", label: "Reorder Level" },
          { name: "reorderQty", label: "Reorder Quantity" },
        ].map((item, idx) => (
          <div key={idx} className="pm-f">
            <label className="pm-flabel">
              {item.label}
              <span className="pm-req">*</span>
            </label>
            <input
              type="number"
              min={0}
              defaultValue={0}
              className={
                "pm-num" +
                (errors?.otherDescription?.[item.name] ? " err" : "")
              }
              {...register(`otherDescription.${item.name}`, {
                required: `${item.label} is required`,
              })}
            />
          </div>
        ))}
      </div>

      {/* ✅ Others */}
      <div className="pm-secthead gap">Others</div>
      <label className="pm-switch">
        <input type="checkbox" {...register("otherDescription.isMenuItem")} />
        <span className="pm-track" />
        Quick Item
      </label>

      {/* 🖼️ Image Upload */}
      <div className="pm-secthead gap">Add Images</div>
      <div className="pm-formgrid">
        {/* Thumbnail Image */}
        <div className="pm-f">
          <span className="pm-flabel">Thumbnail Image</span>
          <label className="pm-drop">
            <span className="pm-ph">
              {thumbnailImage?.length ? (
                thumbnailImage.map((img, idx) => (
                  <img key={idx} src={img.preview} alt={`Thumbnail ${idx + 1}`} />
                ))
              ) : (
                <PmImageIcon />
              )}
            </span>
            <span className="pm-lbl">
              {thumbnailImage?.length ? "Replace the thumbnail" : "Add a thumbnail"}
            </span>
            <span className="pm-pick">Choose file</span>
            <span className="pm-sz">150 × 150 px</span>
            <input
              type="file"
              accept="image/*"
              onChange={handleThumbnailChange}
            />
          </label>
        </div>

        {/* Product Detail Images */}
        <div className="pm-f">
          <span className="pm-flabel">Product Detail Images</span>
          <label
            className={
              "pm-drop" + (productImages.length >= 3 ? " is-disabled" : "")
            }
          >
            <span className="pm-ph">
              <PmGalleryIcon />
            </span>
            <span className="pm-lbl">Up to 3 images</span>
            <span className="pm-pick">Add images</span>
            <span className="pm-sz">550 × 550 px · pick several at once</span>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleProductImagesChange}
              disabled={productImages.length >= 3}
            />
          </label>
          {productImages.length > 0 && (
            <div className="pm-gallery">
              {productImages.map((img, idx) => (
                <span key={idx} className="pm-gitem">
                  <img src={img.preview} alt={`Product ${idx + 1}`} />
                  <button
                    type="button"
                    className="pm-x"
                    aria-label={`Remove image ${idx + 1}`}
                    onClick={() => removeImage(idx)}
                  >
                    <X />
                  </button>
                </span>
              ))}
            </div>
          )}
          <div className={"pm-gcount" + (productImages.length >= 3 ? " full" : "")}>
            {productImages.length >= 3
              ? "Maximum 3 images allowed."
              : `${productImages.length} of 3 images`}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditOtherDescription;
